import { render, staticRenderFns } from "./TileProperties.vue?vue&type=template&id=7e2ddff0"
import script from "./TileProperties.vue?vue&type=script&lang=js"
export * from "./TileProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports